import { normalize, arrayOf } from 'normalizr'
import uniq from 'lodash.uniq'
import traverse from 'traverse'

import { fetch, schemas } from '../utils/fetch'
import { getHash, prepareStructure, addLibrariesToStructure } from '../utils/images'
import { isSuperAdmin } from '../utils/auth'
import { SAVE_DYNAMIC_LINK_SUCCESS } from './dynlinks'
import {
  ENDPOINT_IMAGE_SEARCH,
  ENDPOINT_AGGREGATION
} from '../constants'

const IMAGE_SEARCH_REQUEST = 'blayzr/search/REQUEST'
const IMAGE_SEARCH_SUCCESS = 'blayzr/search/SUCCESS'
const IMAGE_SEARCH_FAILURE = 'blayzr/search/FAIL'

const SEARCH_OPTIONS_SUCCESS = 'blayzr/search/OPTIONS_SUCCESS'
const ADD_IMAGES_TO_ENTITIES = 'blayzr/search/ADD_IMAGES_TO_ENTITIES'

const DEFAULT_PAGE_SIZE = 48

const initialState = {
  options: {
    keywords: null,
    cameras: null,
    keywordMap: null,
    keywordArray: null
  }
}

export default function reducer (state = initialState, action = {}) {
  const { type, payload, meta } = action
  switch (type) {
    case IMAGE_SEARCH_REQUEST:
    case IMAGE_SEARCH_SUCCESS:
    case IMAGE_SEARCH_FAILURE:
      return {
        ...state,
        [meta.key]: searchReducer(state[meta.key], action)
      }
    case SEARCH_OPTIONS_SUCCESS:
      return {
        ...state,
        options: payload
      }
    case SAVE_DYNAMIC_LINK_SUCCESS:
      return {
        options: state.options
      }
    default:
      return state
  }
}

const initialSearchState = {
  data: null,
  fetching: false,
  error: null
}

function searchReducer (state = initialSearchState, action = {}) {
  const { type, payload } = action
  switch (type) {
    case IMAGE_SEARCH_REQUEST:
      return {
        ...state,
        fetching: true,
        error: null
      }
    case IMAGE_SEARCH_SUCCESS:
      const { photos, total_hits, aggs } = payload.result.records
      return {
        ...state,
        fetching: false,
        data: state.data ? uniq(state.data.concat(photos)) : photos,
        count: total_hits,
        keywords: state.keywords || (aggs && aggs.ExpandedKeywords ? aggs.ExpandedKeywords.buckets.sort(sortBuckets) : null),
        resolvedKeywords: traverse(payload.result.query).reduce(function (array, value) {
          if (this.key === 'ExpandedKeywords') array.push(value)
          return array
        }, [])
      }
    case IMAGE_SEARCH_FAILURE:
      return {
        ...state,
        fetching: false,
        error: payload
      }
    default:
      return state
  }
}

function sortBuckets (a, b) {
  return b.doc_count - a.doc_count
}

function notWhitespace (string) {
  return /^\s+$/.test(string) === false
}

export function imageSearchRequest (key) {
  return {
    type: IMAGE_SEARCH_REQUEST,
    meta: { key }
  }
}

export function imageSearchSuccess (key, data) {
  return {
    type: IMAGE_SEARCH_SUCCESS,
    payload: data,
    meta: { key }
  }
}

export function imageSearchFailure (key, error) {
  return {
    type: IMAGE_SEARCH_FAILURE,
    payload: error,
    meta: { key }
  }
}

export function optionsSuccess (data) {
  return {
    type: SEARCH_OPTIONS_SUCCESS,
    payload: data
  }
}

export function addImagesToEntities (images) {
  return {
    type: ADD_IMAGES_TO_ENTITIES,
    payload: normalize(images, arrayOf(schemas.image))
  }
}

const schema = {
  records: {
    photos: arrayOf(schemas.image)
  }
}

export function searchImages (structure, offset = 0, limit, options = {}) {
  return (dispatch, getState) => {
    if (!limit) {
      if (structure.sort.manual) {
        limit = Math.max(structure.sort.manual.length, DEFAULT_PAGE_SIZE)
      } else {
        limit = DEFAULT_PAGE_SIZE
      }
    }

    const { auth, query } = getState()
    const hash = getHash(structure)

    let body = addLibrariesToStructure(structure, query.libraries)
    body = prepareStructure(body)

    let adminSearch
    if (isSuperAdmin(auth.user)) {
      if (body.queries.length === 1 && body.queries[0].path.length !== 0) {
        adminSearch = true
      }
    }

    const fetchOptions = {
      method: 'post',
      query: {
        limit,
        offset,
        simple: options.simple,
        admin_search: adminSearch
      },
      body,
      token: auth.token,
      schema,
      cache: options.cache,
      cacheKey: hash
    }

    dispatch(imageSearchRequest(hash))
    return fetch(ENDPOINT_IMAGE_SEARCH, fetchOptions, dispatch).then(data => {
      dispatch(imageSearchSuccess(hash, data))
    }, e => {
      dispatch(imageSearchFailure(hash, e))
    })
  }
}

export function fetchSearchOptions () {
  return (dispatch, getState) => {
    const { auth } = getState()
    const options = {
      query: { fields: 'keyword,camera,dayperiod,season,tags' },
      token: auth.token
    }
    fetch(ENDPOINT_AGGREGATION, options, dispatch).then(options => {
      const keywords = options.buckets.keyword.filter(item => options.keyword_map[item.key])
      dispatch(optionsSuccess({
        cameras: options.buckets.camera.map(item => item.key).filter(notWhitespace),
        keywords: keywords.map(item => options.keyword_map[item.key].name),
        keywordMap: options.keyword_map,
        keywordArray: keywords.map(item => {
          const info = options.keyword_map[item.key]
          return {
            id: item.key,
            doc_count: item.doc_count,
            keyword: info.name,
            direct_parent_name: info.direct_parent_name,
            top_parent_name: info.top_parent_name,
            synonyms: info.synonyms
          }
        }),
        timesOfDay: options.buckets.dayperiod.map(item => item.key),
        seasons: options.buckets.season.map(item => item.key),
        tags: options.buckets.tags.map(item => item.key)
      }))
    })
  }
}



// WEBPACK FOOTER //
// ./src/redux/search.js